export default class LoginPage {
  constructor(theme) {
    this.theme = theme;

    this.loadPasswordRecover();

    this.forgotPasswordBox = /** @type {HTMLElement} */ (document.querySelector('#forgot-password-box'));
    this.loginBoxLink = /** @type {HTMLElement} */ (document.querySelector('#login-box-link'));
    this.customerLogin = /** @type {HTMLElement} */ (document.querySelector('#customer-login'));
    this.recoverPassword = /** @type {HTMLElement} */ (document.querySelector('#recover-password'));
    this.resetSuccess = /** @type {HTMLElement} */ (document.querySelector('#resetSuccess'));

    let self = this;

    if(this.forgotPasswordBox) {
      this.forgotPasswordBox.addEventListener('click', (e) => {
        self.customerLogin.style.display = 'none';
        self.recoverPassword.style.display = 'block';
      });
    }

    if(this.loginBoxLink) {
      this.loginBoxLink.addEventListener('click', (e) => {
        self.customerLogin.style.display = 'block';
        self.recoverPassword.style.display = 'none';
      });
    }

    if (document.querySelector('.resetSuccessful')) {
      this.resetSuccess.style.display = 'block';
    }
  }

  loadPasswordRecover = () => {
    const recover = /** @type {HTMLElement} */ (document.querySelector('.recover-form'));
    if(!recover) return;
    recover.classList.remove('no-js');

    const showPasswordForm = document.querySelector('.show-password-form');

    if (window.location.hash !== '#recover') {
      recover.classList.add('hide');
    }

    showPasswordForm.addEventListener('click', (e) => {
      recover.classList.toggle('hide');
    });

    showPasswordForm.addEventListener('keypress', (/** @type {KeyboardEvent} */ e) => {
      if (e.code == 'Enter') {
        recover.classList.toggle('hide');
        return false;
      }
    });
  };
}
